import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-saldo-inicial-dialog',
  templateUrl: './saldo-inicial-dialog.component.html',
  styleUrls: ['./saldo-inicial-dialog.component.css']
})
export class SaldoInicialDialogComponent implements OnInit {
  form: FormGroup;
  
  tiposOptions = [
    { value: 'deudor', label: 'Deudor', icon: 'fas fa-arrow-up', description: 'El cliente debe dinero' },
    { value: 'acreedor', label: 'Acreedor', icon: 'fas fa-arrow-down', description: 'La empresa debe al cliente' }
  ];

  constructor(
    public dialogRef: MatDialogRef<SaldoInicialDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.form = this.fb.group({
      monto: ['', [Validators.required, Validators.min(0.01)]],
      tipo: ['deudor', [Validators.required]], // Deudor o Acreedor
      observaciones: ['', [Validators.maxLength(500)]]
    });
  }

  /**
   * Previene la entrada de caracteres no permitidos (como el signo menos)
   */
  onKeyDown(event: KeyboardEvent): void {
    // Prevenir el signo menos (-)
    if (event.key === '-' || event.key === 'Minus') {
      event.preventDefault();
      return;
    }
    
    // Permitir teclas de control (backspace, delete, arrow keys, etc.)
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End'
    ];
    
    if (allowedKeys.includes(event.key)) {
      return;
    }
    
    // Permitir Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
      return;
    }
    
    // Permitir números y punto decimal
    if (!/[0-9.]/.test(event.key)) {
      event.preventDefault();
    }
  }

  /**
   * Valida y corrige el valor del input cuando cambia
   */
  onInputChange(event: any): void {
    let value = event.target.value;
    
    // Si el valor es negativo o empieza con menos, lo corregimos
    if (value < 0 || value.startsWith('-')) {
      // Remover el signo menos y establecer como valor positivo
      value = Math.abs(parseFloat(value)) || '';
      this.form.patchValue({ monto: value });
    }
  }

  guardar(): void {
    if (this.form.invalid) {
      // Marca todos los campos como tocados para mostrar errores
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        control.markAsTouched();
      });
      
      this.snackBar.open('Por favor, complete correctamente todos los campos requeridos', 'Cerrar', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['warning-snackbar']
      });
      return;
    }
    
    // Formatea el número para asegurar que sea un valor numérico válido
    const formValue = this.form.value;
    formValue.monto = parseFloat(formValue.monto);
    
    this.dialogRef.close(formValue);
  }

  cancelar(): void {
    this.dialogRef.close();
  }
}
